import { render } from "./FormTrainingRegionAnchorItem.vue?vue&type=template&id=712c53b4&scoped=true&ts=true"
import script from "./FormTrainingRegionAnchorItem.vue?vue&type=script&lang=ts"
export * from "./FormTrainingRegionAnchorItem.vue?vue&type=script&lang=ts"

import "./FormTrainingRegionAnchorItem.vue?vue&type=style&index=0&id=712c53b4&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712c53b4"]])

export default __exports__